/**
 * Modal do histórico do processo (TB02130) sobre o detalhe V2 da OS.
 * OS nativa (cycles): linha do tempo por ciclo.
 */

import React from 'react';
import { Waypoints } from 'lucide-react';
import { OrderDetailsV2MenuModal } from './OrderDetailsV2MenuModal';
import { OrderDetailsHistoricoProcessoV2 } from './OrderDetailsHistoricoProcessoV2';
import { OrderDetailsHistoricoCiclos } from './OrderDetailsHistoricoCiclos';

export function OrderDetailsHistoricoProcessoModal({
  open,
  onClose,
  orderId,
  steps,
  cycles,
  loading,
  error,
}) {
  const byCycle = !loading && !error && cycles?.cycles?.length > 0;
  return (
    <OrderDetailsV2MenuModal
      open={open}
      onClose={onClose}
      title="Histórico do processo"
      icon={<Waypoints size={18} strokeWidth={2} aria-hidden />}
      orderId={orderId}
      titleId="odv2-historico-modal-title"
      closeAriaLabel="Fechar histórico do processo"
    >
      {byCycle ? (
        <OrderDetailsHistoricoCiclos cycles={cycles.cycles} steps={steps} />
      ) : (
        <OrderDetailsHistoricoProcessoV2 steps={steps} loading={loading} error={error} />
      )}
    </OrderDetailsV2MenuModal>
  );
}
